import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionStatisticsRRPPByRestaurant } from "../../actions/RestaurantActions"
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import { 
  Container, 
  IconButton,
  Button,
  Box, 
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  Input,
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import SearchIcon from '@material-ui/icons/Search';
import ViewDetail from '@material-ui/icons/Visibility';
import Util, { ERROR } from '../../common/Util'
import BackIcon from '@material-ui/icons/ArrowBackRounded';

class StatisticsRRPP extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={page:0, rowPerPage:5, count:0, rrpps:[], filter:"", showPop:false, detailList:[]}
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.onSearch=this.onSearch.bind(this)
  }
  
  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    this.props.actionStatisticsRRPPByRestaurant(this.props.restaurant.id
                                        , this.onChangePage
                                        , (e)=>{console.log("ERROR",e); Util.showNoty(ERROR, "Ocurrió un error al listar las ventas")})
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let filter = new RegExp(this.state.filter,"ig")
    let rrpps = this.props.statsRRPPList.filter((r)=>{return `${r.lastName}, ${r.name}`.match(filter)})
    let count = rrpps.length
    rrpps = rrpps.slice(from, end)
    this.setState({page:newPage, count:count, rrpps:rrpps})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let filter = new RegExp(this.state.filter,"ig")
    let rrpps = this.props.statsRRPPList.filter((r)=>{return `${r.lastName}, ${r.name}`.match(filter)})
    let count = rrpps.length
    rrpps = rrpps.slice(from, end)
    this.setState({rowPerPage:evt.target.value, count:count, rrpps:rrpps})
  }

  onSearch(evt){
   this.setState({filter:evt.target.value},this.onChangePage)
  }



  renderTableHeader(){
    // const {theme} = this.props
    const headers = ["RRPP","Venta directa", "Referenciadas"]
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      {/* <TableCell style={theme.table.actionsColumn}>Acciones</TableCell> */}
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let rrpps = this.state.rrpps
    if(!rrpps||rrpps.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    return rrpps.map((item, index)=>{
      // console.log(index, item)
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>{item.name} {item.lastName}</TableCell>
          <TableCell>
            {Util.formatCurrency(item.standard&&item.standard.totalAmmount)}
            {item.standard&&
              <IconButton onClick={()=>{this.setState({showPop:true, rrpp:item, direct:true, detailList:item.standard.ticketTypes})}}>
                <ViewDetail/>
              </IconButton>
            }
          </TableCell>
          <TableCell>
            {Util.formatNumber(item.rrppsell&&item.rrppsell.totalQt)||0}
            {item.rrppsell&&
              <IconButton onClick={()=>{this.setState({showPop:true, rrpp:item, direct:false, detailList:item.rrppsell.ticketTypes})}}>
                <ViewDetail/>
              </IconButton>
            }
          </TableCell>

          {/* <TableCell style={{...theme.table.actionsColumn, minWidth:256}}>
            <Tooltip title="Estadísticas del evento">
              <IconButton onClick={this.onStadisticRestaurant.bind(this, item)}>
                <StatisticsIcon/>
              </IconButton>
            </Tooltip>
           
          </TableCell> */}
        </TableRow>
      )
    })
  }

  render(){
    const { theme, restaurant} = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Vendidas por RRPP</Typography>
            <Typography variant="subtitle1">Restauranto {restaurant.evtName}</Typography>
          </Box>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Typography style={theme.paper.title} variant="h2">{restaurant.evtName}</Typography>
            <Toolbar style={{...theme.table.toolbar, justifyContent:"flex-end"}}>
              <Box> 
                <Input placeholder="Buscar" onChange={this.onSearch}/>
              </Box>
            </Toolbar>
              <Table stickyHeader>
                <TableHead > 
                  {this.renderTableHeader()}
                </TableHead>
                <TableBody>
                  {this.renderTableBody()}
                </TableBody>
              </Table> 
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.showPop}>
            <DialogTitle>{this.state.rrpp&&this.state.rrpp.name} {this.state.rrpp&&this.state.rrpp.lastName}</DialogTitle>
            <DialogContent>
              <DialogContentText>{this.state.direct?"Venta directa":"Referenciadas"}</DialogContentText>
              <Table stickyHeader style={{minWidth:500, boxShadow:"0 2px 4px 0 rgba(0, 0, 0, 0.23)"}}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{backgroundColor:"#f6f6f6"}}>Ticket</TableCell>
                    <TableCell style={{backgroundColor:"#f6f6f6"}} align="right" >Cantidad</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.detailList.map((d, index)=>{
                    return (
                      <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
                        <TableCell>{this.state.direct?`${d.totalQt} - ${d.tktTypeData.tktDisplayName}`:d.tktTypeData.tktDisplayName}</TableCell>
                        <TableCell align="right">{this.state.direct?Util.formatCurrency(d.totalAmmount):Util.formatNumber(d.totalQt)}</TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" color="primary" onClick={()=>this.setState({showPop:false})}>Cerrar</Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    statsRRPPList: store.evt.statsRRPPList||[],
    restaurant: store.evt.eventStats
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionStatisticsRRPPByRestaurant
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(StatisticsRRPP)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/restaurants/StatisticsRRPP.js